<script lang="ts" setup>
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    isOpen: {
        type: Boolean,
        default: false
    },
    chevronRight: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <button :class="['flex-container align-justify align-middle width-100', { active: props.isOpen }]">
        <div class="grid-x align-middle sy-spacer-x-5">
            <Icon
                v-if="!chevronRight"
                icon="chevron-right"
                :class="['sy-icon-transition',{ 'sy-icon-rotate-90': props.isOpen }]"
                data-testid="accordion-header-icon"
            ></Icon>
            <span class="cell auto text-left sy-pre-wrap">{{ title }}</span>
            <Icon
                v-if="chevronRight"
                icon="chevron-right"
                :class="['sy-icon-transition',{ 'sy-icon-rotate-90': props.isOpen }]"
                data-testid="accordion-header-icon"
            ></Icon>
        </div>
        <slot></slot>
    </button>
</template>
